export const LABELS = {
    ADD_PAYMENT_METHOD: 'Add Payment Method',
    ADDING: 'Adding',
    PROCESS_PAYMENT: 'Process Payment',
    PROCESSING: 'Processing',
}
